// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"style_titleWrapper__34F2D","rowsWrapper":"style_rowsWrapper__15fWt","rowWrapper":"style_rowWrapper__SzUyw"};